<template>
  <div class="balls-result-wr" :class="{'single-col': !bonusBall}">
    <div><b>{{ meeting.time }}</b></div>
    <div v-if="bonusBall" class="cell-x-center"><b>BONUS</b></div>
    <div class="main-balls">
        <lotto-ball-number v-for="(ball, index) in mainBalls" :key="index" class="ball-item" :is-smaller="isSmaller"  :number="ball.label"></lotto-ball-number>
    </div>
    <div v-if="bonusBall" class="cell-x-center">
        <lotto-ball-number class="ball-item"  :is-smaller="isSmaller" :number="bonusBall"></lotto-ball-number>
    </div>
  </div>
</template>

<script>
  import LottoBallNumber from "@/components/UI/LottoBallNumber";

  export default {
    name: "LottoMeetingResult",
    components: {
      LottoBallNumber
    },
    props: {
      meeting: {
        
      },
      isSmaller: {
        type: Boolean,
      }      
    },
    computed: {
      mainBalls() {
        return this.meeting.results?.filter(el => !el.isBooster)
      },
      bonusBall() {
        return this.meeting.results?.find(el => el.isBooster)?.label
      },
      
    }
  }
</script>

<style scoped lang="scss">
  .balls-result-wr {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 0.5rem 1rem;
    align-items: center;

    // small balls for smaller screens
    @media only screen and (max-width: 380px) {
      grid-gap: 0.5rem;
    }

    &.single-col {
      grid-template-columns: auto;
    }

    .cell-x-center {
      justify-self: center;
    }

    .main-balls {
      display: flex;
      gap: 0.5rem;
    }
  }


</style>